import { useCallback, useMemo } from 'react';

import { useServiceAppState } from '@kc-console/context';

import { useMegaMenuState } from '../../../hooks';
import Content from './Content';
import GlobalSidebar from './GlobalSidebar';
import Header from './Header';
import { MegaMenuBackdrop, MegaMenuBodyContainer, MegaMenuContainer } from './MegaMenuLayout';
import Sidebar from './Sidebar';

const MegaMenu = () => {
  const {
    state: { region },
  } = useServiceAppState();
  const { isOpen, setIsOpen } = useMegaMenuState();

  const hasRegion = useMemo(() => !!region, [region]);

  const onClose = useCallback(() => setIsOpen(false), [setIsOpen]);

  return (
    <div>
      {isOpen && <MegaMenuBackdrop open onClick={onClose} />}
      <MegaMenuContainer isOpen={isOpen} hasRegion={hasRegion}>
        <Header onClose={onClose} />
        <MegaMenuBodyContainer>
          {hasRegion ? (
            <>
              <Sidebar />
              <Content />
            </>
          ) : (
            <GlobalSidebar />
          )}
        </MegaMenuBodyContainer>
      </MegaMenuContainer>
    </div>
  );
};

export default MegaMenu;
